const typograhy = {
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.125,
    short: 1.25,
  },

  fontWeights: {
    light: 300,
    normal: 400,
    bold: 700,
  },

  fonts: {
    body: "AvenirNextLTPro, sans-serif",
    heading: null,
  },

  fontSizes: {
    "4xs": "0.5rem", // 8px
    "3xs": "0.625rem", // 10px
    "2xs": "0.6875rem", // 11px
    xs: "0.75rem", // 12px
    "2sm": "0.8125rem", // 13px
    sm: "0.875rem", // 14px
    md: "0.9375rem", // 15px

    lg: "1.125rem", // 18px
    "2lg": "1.1875rem", // 19px
    xl: "1.25rem", // 20px
    "2xl": "1.625rem", // 26px
    "3xl": "2rem", // 32px
    "4xl": "3.25rem", // 52px
    "5xl": "4rem", // 64px
    "6xl": null,
    "7xl": null,
    "8xl": null,
    "9xl": null,
  },
}

export default typograhy
